module.exports = __webpack_public_path__ + "img/goal-12.c96b79eb.png";